import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-switch-button',
  templateUrl: './switch-button.component.html',
  styleUrls: ['./switch-button.component.scss'],
})
export class SwitchButtonComponent implements OnInit {
  @Input() options: any[] = [];
  @Input() id: string = '';
  @Input() field: string = 'name';
  @Input() valueField: string = 'value';
  @Input() paddingClass: string = 'p-2';
  @Input() value: any = {};
  @Input() fontSize: number = 12;
  @Input() showIcons: boolean = false;
  @Input() disabled: boolean = false;
  @Input() showselectedCircle: boolean = true;

  @Output() appChange = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {}

  handleChange(value: any) {
    if (this.disabled) {
      return;
    }

    this.appChange.emit(value);
  }
}
